import { useSelectedOfferPricing } from 'publisher/pages/offer-page/hooks/useSelectedOfferPricing'
import { usePayment } from 'publisher/store'
import {
  getActivePricePlan,
  getCheckedBump,
  getOfferPricing,
  getProduct,
  getProductActiveVariant,
} from 'publisher/store/payment/paymentSelectors'
import { useCalculatedPricePlans } from 'src/publisher/hooks/use-calculated-price-plans'

/**
 * Derives offer pricing values from the Redux store.
 * Safe to call from any component — contains no fetch side effects.
 */
export const useOfferPricing = () => {
  const product = usePayment(getProduct)
  const activePricePlan = usePayment(getActivePricePlan)
  const activeProductVariant = usePayment(getProductActiveVariant)
  const bump = usePayment(getCheckedBump)
  const productBump = bump?.product || null
  const bumpPlan = bump?.pricePlans[0]

  const { pricePlans } = useCalculatedPricePlans()
  const offerPricing = usePayment(getOfferPricing)

  const selectedOfferPricing = useSelectedOfferPricing({
    selectedProduct: product,
    selectedPricePlan: activePricePlan,
    activeProductVariant,
  })

  const physicalMainOfferPricing = useSelectedOfferPricing({
    selectedProduct: product,
    activeProductVariant,
  })

  const physicalBumpOfferPricing = useSelectedOfferPricing({
    selectedProduct: productBump,
  })

  const digitalBumpOfferPricing = useSelectedOfferPricing({
    selectedPricePlan: bumpPlan,
  })

  const digitalOfferPricings = offerPricing?.filter(calculatedPricing =>
    pricePlans.some(pricePlan => pricePlan.id === calculatedPricing.pricePlan),
  )

  return {
    selectedOfferPricing,
    physicalMainOfferPricing,
    physicalBumpOfferPricing,
    digitalOfferPricings,
    digitalBumpOfferPricing,
  }
}
